import React from 'react';
import picture from '../assets/newcomers1.png';
import ModernHero from './modern/ModernHero';

// Board-specific bits only; the design is shared (src/components/modern, 2026-10-02 refresh).
// Words are in sites/refugee/site.json "home".
export default function Hero() {
  return <ModernHero image={picture} />;
}
